import type { NUtils } from '@app/types/Utils';

export const createUserPrint: NUtils.CreateUserPrint = ({
  userId,
  database,
  activeBranchId,
}) => {
  return {
    UserId: userId,
    Database: database,
    ActiveBranchId: activeBranchId,
  };
};
